import { render, staticRenderFns } from "./PaymentsCompletedView.vue?vue&type=template&id=6d0ae843&scoped=true"
import script from "./PaymentsCompletedView.vue?vue&type=script&lang=js"
export * from "./PaymentsCompletedView.vue?vue&type=script&lang=js"
import style0 from "./PaymentsCompletedView.vue?vue&type=style&index=0&id=6d0ae843&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0ae843",
  null
  
)

export default component.exports